import { render } from "./BaseEmailTagInput.vue?vue&type=template&id=6e30f34d&scoped=true"
import script from "./BaseEmailTagInput.vue?vue&type=script&lang=js"
export * from "./BaseEmailTagInput.vue?vue&type=script&lang=js"

import "./BaseEmailTagInput.vue?vue&type=style&index=0&id=6e30f34d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e30f34d"]])

export default __exports__